import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div
      className="pb-4"
      style={{
        background: "white",
        borderTop: "1px solid #cbcbcb",
        marginTop: "6.5rem ",
      }}
    >
      {/* <div className="pb-4 pt-4" style={{ textAlign: "center", background: "#369b8e" }}>
        <h1>Start writing your own blogs</h1>
        <Link to="/login">
          <button style={{ width: "fit-content" }} class="btn btn-primary buttonb">
            GET STARTED
          </button>
        </Link>
      </div> */}
      <div className="container pt-4">
        <div className="row">
          <div className="col-lg-6">
            <img src={require("../../Assets/ca-labs-logo.png")} width="160px" />
            {/* <h2 className="font-weight-bold">CA LABS</h2> */}
            <div></div>
            <p>
              <br />
              <b>ABOUT</b>
            </p>
            <p>
              We provide All the services and facilities that are provided in CA roadways. We are a
              team of CA professionals and Entrepreneurs who are on a task to digitalize all the
              Commerce tasks a CA does thereby making your finance life easier and providing
              financial stability.
            </p>
            <p>CA LABS &copy; 2020</p>
          </div>
          <div className="col-lg-6 pl_10p">
            <br />
            <p style={{ marginBottom: "2px" }}>
              <b>EXPLORE:</b>
            </p>
            <Link to="/about-us" className="fbold tblue">
              CA Labs About
            </Link>
            <br />
            <Link to="/" className="fbold tblue">
              Services
            </Link>
            <br />
            <Link to="/services/tax" className="fbold tblue">
              ITR services
            </Link>
            <br />
            <Link to="/services/company-registration" className="fbold tblue">
              Company registration
            </Link>
            <br />
            <Link to="/kitnatax" className="fbold tblue">
              Tax calculator tool
            </Link>
            <br />
            <p>
              Contact us at :<br /> <b>calab.connect@gmail.com</b>
            </p>
            <p className="fbold tblue">
              FOLLOW US ON<i class="fab fa-linkedin pl-2 fs30px"></i>{" "}
              <i class="fab fa-facebook-square fs30px"></i>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
